(function () {
  'use strict';

  if (!window.__accessControl || !window.__accessControl.length) return;

  function clearSafetyTimers() {
    var timers = window.__accessControlSafetyTimers;
    if (!timers || !timers.length) return;
    timers.forEach(function (id) {
      clearTimeout(id);
    });
    timers.length = 0;
  }

  // イベント予約テンプレート等では access-control スニペットが複数セクションから
  // render されるため、オーバーレイも複数枚存在しうる。必ず全て削除する。
  function removeOverlays() {
    clearSafetyTimers();
    document.querySelectorAll('.access-control-overlay').forEach(function (el) {
      el.remove();
    });
  }

  function ensureOverlay() {
    // 既存のオーバーレイを撤去してから1枚だけ作り直し、重複した id・role が
    // リダイレクト待ちの間ずっと残らないようにする。
    removeOverlays();
    if (document.body) {
      var div = document.createElement('div');
      div.className = 'access-control-overlay';
      div.setAttribute('role', 'status');
      div.setAttribute('aria-label', '読み込み中');
      var spinner = document.createElement('div');
      spinner.className = 'access-control-overlay__spinner';
      div.appendChild(spinner);
      document.body.appendChild(div);
    }
  }

  // プレビュー専用ドメインには顧客セッションが無く、必ず未ログイン判定になる。
  // そのままログインへ飛ばすと OAuth の redirect_uri がプレビュードメインになり
  // 「redirect_uriが一致していません」エラーで商品ページを確認できないため、
  // プレビュー時はランク判定そのものをスキップする。
  // 判定材料はホスト名と Shopify.designMode のみ。preview_key や preview_theme_id は
  // 値の正当性をクライアント側で検証できず、URLにクエリを足すだけで制限を
  // 回避できてしまうため使わない。
  function isPreviewContext() {
    var host = location.hostname;
    // 管理画面の商品プレビュー・テーマプレビュー
    if (/(^|\.)shopifypreview\.com$/.test(host)) return true;
    // shopify theme dev
    if (host === '127.0.0.1' || host === 'localhost') return true;
    // テーマエディタ内プレビュー
    if (window.Shopify && window.Shopify.designMode) return true;
    return false;
  }

  function showPreviewNotice() {
    if (!document.body) return;
    if (document.getElementById('access-control-preview-notice')) return;
    var el = document.createElement('div');
    el.id = 'access-control-preview-notice';
    el.className = 'access-control-preview-notice';
    el.textContent = 'プレビュー表示: 会員ランク制限をスキップしています';
    document.body.appendChild(el);
  }

  if (isPreviewContext()) {
    // テーマエディタではセクション設定を変えるたびに静的オーバーレイが
    // 挿入し直されるため、再描画のたびに消す。
    document.addEventListener('shopify:section:load', removeOverlays);
    removeOverlays();
    showPreviewNotice();
    return;
  }

  if (!window.customerReady) {
    removeOverlays();
    return;
  }

  var rules = window.__accessControl;

  var gatedButtons = document.querySelectorAll('[data-access-gate]');
  gatedButtons.forEach(function (el) {
    // Coming Soon・SOLD OUT等で元々無効なボタンには一切触れない。
    // ここで aria-disabled を足すと、後段(theme.jsのバリアント切替等)が disabled だけを
    // 外した際に「操作可能なのに支援技術には無効」という不整合が残るため。
    if (el.hasAttribute('disabled')) {
      return;
    }
    el.setAttribute('data-access-gate-locked', '');
    el.setAttribute('disabled', 'disabled');
    el.setAttribute('aria-disabled', 'true');
  });

  window.customerReady.then(function (customer) {
    var loggedIn = !!customer;
    var rank = loggedIn && customer.clubhers_rank ? customer.clubhers_rank : '';
    var allowed = loggedIn && rules.every(function (rule) {
      return rule.allowedRanks.indexOf(rank) !== -1;
    });

    if (allowed) {
      gatedButtons.forEach(function (el) {
        // このスクリプトが無効化したボタンのみ解除する
        if (!el.hasAttribute('data-access-gate-locked')) {
          return;
        }
        el.removeAttribute('data-access-gate-locked');
        el.removeAttribute('disabled');
        el.removeAttribute('aria-disabled');
      });
      removeOverlays();
      return;
    }

    ensureOverlay();
    var firstRule = rules[0];
    location.href = loggedIn ? (firstRule.homeUrl || '/') : firstRule.loginUrl;
  });
})();
